export default __webpack_public_path__ + "static/media/fortuneIcon.7ca08dd8.svg";